import { Link } from "react-router-dom";
import {
  Landmark, GraduationCap, Briefcase, Shield, BadgeCheck, Building2, Brain, Layers, BookOpen, Award, Target, Compass, Star, Flag,
} from "lucide-react";

export const ICONS = { landmark: Landmark, "graduation-cap": GraduationCap, briefcase: Briefcase, shield: Shield, "badge-check": BadgeCheck,
  "building-2": Building2, brain: Brain, layers: Layers, "book-open": BookOpen, award: Award, target: Target, compass: Compass, star: Star, flag: Flag };

export const CategoryIcon = ({ name, className = "h-6 w-6" }) => {
  const I = ICONS[name] || Layers;
  return <I className={className} />;
};

export const Logo = ({ light = false, to = "/" }) => (
  <Link to={to} data-testid="brand-logo" className="flex items-center gap-2.5 group">
    <img src="/images/logo-mark.png" alt="Logo Adikara Academy" className={`h-11 w-auto object-contain ${light ? "rounded-lg bg-white p-1" : ""}`} />
    <span className="leading-tight">
      <span className={`block font-display text-[15px] font-extrabold tracking-[0.14em] ${light ? "text-white" : "text-[#0A192F]"}`}>ADIKARA</span>
      <span className="block text-[10px] font-semibold tracking-[0.32em] text-amber-500">ACADEMY</span>
    </span>
  </Link>
);

export const FullLogo = ({ className = "h-24" }) => (
  <img src="/images/logo-full.png" alt="Adikara Academy — Langkah Cerdas, Raih Prestasi." className={`w-auto object-contain ${className}`} data-testid="brand-full-logo" />
);

export const Spinner = ({ label = "Memuat..." }) => (
  <div data-testid="loading-indicator" className="flex items-center justify-center gap-3 py-16 text-slate-500">
    <span className="h-5 w-5 animate-spin rounded-full border-2 border-amber-500 border-t-transparent" />
    <span className="text-sm">{label}</span>
  </div>
);

export const Empty = ({ text, testid = "empty-state" }) => (
  <div data-testid={testid} className="rounded-xl border border-dashed border-slate-300 bg-white/60 p-10 text-center text-sm text-slate-500">{text}</div>
);

export const NativeSelect = ({ className = "", children, ...props }) => (
  <select className={`field ${className}`} {...props}>{children}</select>
);
